export default __webpack_public_path__ + "static/media/map-red-marker.fceb287c.svg";